var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"all"},[_c('div',{staticClass:"HomeInput"},[_c('Homseach')],1),_c('div',{staticClass:"EmptyState_a"},[_c('p',[_vm._v("Search Result")]),_c('EmptyState')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }